$('#eras')
    .slick({
        dots: false,
        arrows: true,
        infinite: false,
        speed: 300,
        slidesToShow: 7,
        slidesToScroll: 7,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 6,
                    slidesToScroll: 6,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 4
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3
                }
            }
            // You can unslick at a given breakpoint now by adding:
            // settings: "unslick"
            // instead of a settings object
        ]
    });
$('#eras')
    .on('afterChange', function(event, slick, currentSlide){
        carouselCallback(event);
    });

function carouselCallback(e) {
    const children = e.target.querySelectorAll('.slick-active');
    if (children.length > 0) {
        children[children.length - 1].querySelector('a')
            .click();
    }
}

function historyFilter(era) {
    if (!era.textContent || era.textContent.length === 0) {
        return;
    }
    const years = [];
    for (const item of document.querySelectorAll('#eras .slick-active .era-item')) {
        years.push(parseInt(item.textContent.trim()));
    }
    const historyContents = document.getElementById('history-contents');
    const items = historyContents.querySelectorAll('.history-item');
    for (const item of items) {
        if (years.indexOf(parseInt(item.dataset.year)) === -1) {
            item.style.display = 'none';
        } else {
            item.style.display = '';
        }
    }

}

const eras = document.querySelectorAll('.era-item > a');
if (eras.length) {
    for (const era of eras) {
        era.addEventListener('click', e => {
            historyFilter(era);
        });
    }
    historyFilter(eras[0]);
}
